export default "__VITE_ASSET__20140150__"